import { render, staticRenderFns } from "./clinical.vue?vue&type=template&id=21198232&scoped=true"
import script from "./clinical.vue?vue&type=script&lang=js"
export * from "./clinical.vue?vue&type=script&lang=js"
import style0 from "./clinical.vue?vue&type=style&index=0&id=21198232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21198232",
  null
  
)

export default component.exports